export default "__VITE_ASSET__CsloGg11__ 400w, __VITE_ASSET__Cy_pnnVh__ 800w, __VITE_ASSET__CA44CBM___ 1024w";